import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { Colors, ContentSpacing } from '@estee/elc-base-theme';
import { Body2 } from '@estee/elc-typography';

import { inheritBaseFont } from '~theme/default-theme';
import { classes } from '~utils/ClassNames';
import {
    ISpinnerSelector,
    SpinnerSelector
} from '~sharedComponents/SpinnerSelector/SpinnerSelector';
import { useTranslation } from '~sharedComponents/Providers/Translations/TranslationsHook';

import IQuantityItem from './IQuantityItem';

const Quantity = styled.div`
    display: flex;
    align-items: center;
    padding-top: ${ContentSpacing.space8};
`;
const QtyLabel = styled(Body2)`
    color: ${Colors.primary700};
    font-size: ${ContentSpacing.space12};
    ${inheritBaseFont};
`;

export const quantityLabelClass = classes('cart-item-description-product-quantity-label');
export const numberSpinnerClass = classes(
    'cart-item-description-product-quantity-spinner-selector'
);

const QuantityItem: React.FC<IQuantityItem & ISpinnerSelector> = observer((props) => {
    const { className, skuId, readOnly, quantity, ...spinnerSelectorProps } = props;

    const { quantityLabel } = useTranslation(['quantityLabel']);
    const quantityClass = classes('cart-item-description-product-quantity', className);
    const qtyLabel = quantityLabel ? `${quantityLabel} ${quantity}` : quantity;

    return (
        <Quantity
            className={quantityClass}
            data-testid={quantityClass}
            aria-controls={`item-total-${skuId}`}
        >
            {readOnly ? (
                <QtyLabel
                    className={quantityLabelClass}
                    data-testid={quantityLabelClass}
                    aria-selected="true"
                >
                    {qtyLabel}
                </QtyLabel>
            ) : (
                <SpinnerSelector
                    className={numberSpinnerClass}
                    quantity={quantity}
                    {...spinnerSelectorProps}
                />
            )}
        </Quantity>
    );
});
export default QuantityItem;
